const $inject = ['$rootScope'];
const lbaLoaderCtrl = function ($rootScope) {
  let vm = this;

  $rootScope.$on('lbaLoader:loaderState', (event, message) => {
    vm.showLoader = message.state;
    vm.loaderText = message.text;
  });
};

lbaLoaderCtrl.$inject = $inject;

export default lbaLoaderCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaLoader/lbaLoaderCtrl.js